/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UiText } from './uiText';


export interface UiNodeAnchorAttributes { 
    /**
     * The link\'s href (destination) URL.  format: uri
     */
    href: string;
    /**
     * A unique identifier
     */
    id: string;
    /**
     * NodeType represents this node\'s types. It is a mirror of `node.type` and is primarily used to allow compatibility with OpenAPI 3.0.  In this struct it technically always is \"a\". text Text input Input img Image a Anchor script Script
     */
    node_type: UiNodeAnchorAttributes.NodeTypeEnum;
    title: UiText;
}
export namespace UiNodeAnchorAttributes {
    export type NodeTypeEnum = 'text' | 'input' | 'img' | 'a' | 'script';
    export const NodeTypeEnum = {
        Text: 'text' as NodeTypeEnum,
        Input: 'input' as NodeTypeEnum,
        Img: 'img' as NodeTypeEnum,
        A: 'a' as NodeTypeEnum,
        Script: 'script' as NodeTypeEnum
    };
}


